import { ActionTypes } from "../constants/action-types"

export const setDirection = (direction) => {
    return {
        type: ActionTypes.SET_DIRECTION,
        payload: direction
    }
}

